<template>
  <div class="application">
    <transition name="fade">
      <intro-section
        v-if="step == 1"
        title="Bank Details"
        body="We're looking forward to working together. Our job is to provide you with options as unique as your business. To do this, we need to learn a little bit more about you."
        btn_text="Get Started"
        icon="bank"
        v-on:next="next(2)"
      ></intro-section>
    </transition>

    <template>
      <progress-bar
        v-if="step > 1 || step == null"
        :questions_total="total_questions"
        :question_num="previous_step - 2 + answered_questions"
        phase="Application Approval"
        :category_label="questions[previous_step - 2].category"
      ></progress-bar>

      <transition name="fade">
        <div class="questions" v-if="step > 1">
          <questions
            :step="step"
            question_title="bank"
            :questions="questions"
            v-on:saveAnswer="saveAnswer"
          ></questions>
        </div>
      </transition>
    </template>

    <transition name="fade">
      <saving-info
        v-if="save_info_screen"
        title="Saving Your Bank Information"
        body="Please wait a moment while we save your information."
      ></saving-info>
    </transition>
  </div>
</template>

<script>
import { db, functions } from "@/config/firebaseInit";
import Section from "@/components/Application/Section";
import Progress from "@/components/Application/Progress";
import Questions from "@/components/Application/Questions";
import QuestionsList from "@/components/Application/Questions.json";
import SavingInfo from "@/components/Application/SavingInfo";

export default {
  name: "Bank",
  components: {
    "intro-section": Section,
    "progress-bar": Progress,
    questions: Questions,
    "saving-info": SavingInfo,
  },
  data() {
    return {
      answers: {},
      answered_questions: 0,
      save_info_screen: false,
      step: this.$store.state.application_approval_step,
      previous_step: 2,
      questions: QuestionsList["bank"],
      total_questions: 0,
    };
  },
  created() {
    let questions = 0;
    for (var key in QuestionsList) {
      if (key == "bank") {
        this.answered_questions = questions;
      }
      questions += QuestionsList[key].length;
      console.log(key, questions);
    }
    this.total_questions = questions;
  },
  methods: {
    next(step) {
      this.step = null;
      setTimeout(() => {
        this.step = step;
      }, 500);
    },
    saveAnswer(name, answer) {
      this.answers[name] = answer;
    },
    saveData() {
      this.save_info_screen = true;
      let data = {
        bank: this.answers,
        status: "debt",
      };
      this.$store.commit("setUser", data);

      db.collection("user")
        .doc(this.$store.state.user_id)
        .set(data, { merge: true })
        .then(() => {
          setTimeout(() => {
            this.$parent.step = null;
            setTimeout(() => {
              this.$parent.step = "debt";
            }, 500);
          }, 2000);
        });
    },
  },
};
</script>

<style lang="scss">
.intro {
  height: auto;
  min-height: 100vh;
  background: rgba(11, 110, 251, 0.08);
  width: 100%;
  text-align: center;
  .contain {
    display: flex;
    justify-content: center;
    flex-direction: column;
    min-height: 100vh;
    max-width: 700px;
    .icon {
      height: 70px;
      margin-bottom: 30px;
    }
    h1 {
      font-size: 50px;
    }
  }
}

.questions {
  max-width: 450px;
  width: 100%;
  margin: auto;
  margin-top: 30px;
}
</style>
